<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="599px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title>
        <span class="headline">
          <v-icon class="toolbar-icon" v-text="getTitle_.icon"/>
          {{ getTitle_.title }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog(true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-1">
        <v-container
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
          class="overflow-y-auto dialog-scrollbar"
          style="max-height: 400px; padding: 9px 0px !important;"
        >
          <v-form
            ref="SaveForm"
            v-model="valid"
            lazy-validation
            :disabled="get_interface.loading"
            class="cash-form"
          >
            <v-row v-if="fixed === 0" class="cash-form-row">
              <v-col cols="7">
                <v-select
                  v-model="selected.type"
                  :items="get_global.defaults.options.financial.cashflow.types"
                  :label="lang.financial.cashflow.new.form.type"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading || (id > 0)"
                  prepend-inner-icon="mdi-format-list-bulleted-type"
                  item-text="title"
                  item-value="id"
                  attach
                  filled
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="5">
                <DatetimePicker
                  :label="lang.financial.cashflow.new.form.date"
                  v-model="selected.datetime"
                />
              </v-col>
            </v-row>
            <v-row class="cash-form-row">
              <v-col cols="12" lg="8" md="8" sm="12" class="py-0 px-1">
                <v-text-field
                  v-model="selected.title"
                  :label="lang.financial.cashflow.new.form.title"
                  :rules="lang.financial.cashflow.new.form.rules.title"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  autocomplete="new-password"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="4" md="4" sm="12" class="py-0 px-1">
                <div class="total-select">
                  <v-checkbox
                    v-model="autoprice"
                    class="autoprice"
                    light
                    hide-details
                  ></v-checkbox>
                  <v-currency-field
                    v-model="selected.value"
                    :label="lang.financial.cashflow.new.form.value"
                    :rules="lang.financial.cashflow.new.form.rules.value"
                    :loading="get_interface.loading"
                    :disabled="get_interface.loading || autoprice"
                    class="totalprice"
                    filled
                    hide-details
                  />
                </div>
              </v-col>
            </v-row>
            <template v-if="selected.type < 2">
              <v-row class="pa-0">
                <v-col cols="12" class="pa-0 px-1 pb-3">
                  <Order
                    v-model="selected.order"
                  />
                </v-col>
              </v-row>
              <v-row class="cash-form-row">
                <v-col cols="12">
                  <v-select
                    v-model="selected.method"
                    :items="get_global.defaults.options.financial.cashflow.methods"
                    :label="lang.financial.cashflow.new.form.method"
                    :loading="get_interface.loading"
                    :disabled="get_interface.loading"
                    prepend-inner-icon="mdi-credit-card-multiple-outline"
                    item-text="title"
                    item-value="id"
                    attach
                    filled
                    dense
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row v-if="fixed === 0" class="pa-0">
                <v-col cols="12" class="pa-0 px-1">
                  <v-select
                    v-model="selected.category"
                    :items="get_global.defaults.options.financial.cashflow.categories"
                    :label="lang.financial.cashflow.new.categories.title_s"
                    :loading="get_interface.loading"
                    :disabled="get_interface.loading"
                    prepend-inner-icon="mdi-hexagon-multiple"
                    item-text="title"
                    item-value="id"
                    attach
                    filled
                    dense
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="selected.category <= 3 || selected.category === 5" class="pa-0">
                <v-col cols="12" class="pa-0 px-1 pt-3">
                  <v-alert
                    dense
                    border="left"
                    type="warning"
                  >
                    {{ lang.financial.cashflow.new.form.advertise(selected.category) }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row class="pa-0">
                <v-col cols="12" class="pa-3 px-1">
                  <Meta
                    v-model="selected.meta"
                    :category="(fixed === 0 ? selected.category : fixed)"
                    :key="selected.category"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row class="cash-form-row">
              <v-col cols="12">
                <v-textarea
                  v-model="selected.notes"
                  :label="lang.financial.cashflow.new.form.notes"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  :rows="2"
                  clear-icon="mdi-broom"
                  counter="470"
                  filled
                  auto-grow
                  clearable
                  hide-details
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog(true)">{{ lang.items.view.close }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="save_(selected)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          {{ lang.items.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Order from '@/components/orders/templates/UnpaidAutoComplete'
import Meta from './templates/Meta'
import DatetimePicker from '@/components/utils/DatetimePicker'

import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'
import utils from '@/mixins/utils'
import cashflow from './mixins/index'

export default {
  components: { Order, Meta, DatetimePicker },
  mixins: [ appdata, save, utils, cashflow ],
  props: {
    fixed: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      valid: false,
      autoprice: (this.id < 1),
      datemenu: false
    }
  },
  computed: {
    getTitle_ () {
      let action = (this.id < 1 ? 'new' : 'edit'),
          page = (this.selected.type < 2 ? 'payment' : 'expense'),
          title_s = this.lang.financial.cashflow.new.types[page]
      return {
        icon: `mdi-playlist-${(this.id > 0 ? 'edit' : 'plus')}`,
        title: `${this.lang.financial.cashflow.actions[action]} ${title_s}${(this.id > 0 ? ' #' + this.id : '')}`,
        title_s
      }
    }
  },
  watch: {
    autoprice (val) {
      this.$nextTick(() => {
        if (val) this.totalSum()
      })
    },
    'selected.order': {
      deep: true,
      handler () {
        this.$nextTick(() => {
          if (this.autoprice) this.totalSum()
        })
      } 
    },
    'selected.meta': {
      deep: true,
      handler () {
        this.$nextTick(() => {
          if (this.autoprice) this.totalSum()
        })
      } 
    }
  },
  methods: {
    totalSum () {
      let sum = 0
      if (this.selected.type < 2) {
        if (typeof this.selected.order.id !== 'undefined') {
          let orders = this.get_data.orders || [],
              order = orders.find(o => o.id === this.selected.order.id || 0) || {}
          console.log('totalSum', { orders, order, id: this.selected.order.id })
          sum = parseFloat(order.total_left || 0)
        }
      } else {
        sum = (this.selected.meta || []).reduce((acc, curr) => {
          let value = this.unformatCurrency(curr[(curr.length - 1)] || '0') || 0
          return parseFloat(acc + value) || 0
        }, 0)
      }
      this.selected.value = sum
    }
  }
}
</script>

<style src="./styles/save.scss" lang="scss"></style>
